module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0747f_logo_200x200.2154bcd6.png";